import React, { useEffect, useState } from 'react';
import { ScrollRestoration } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { Footer } from './template';

import brainSvg from 'bundle-text:./assets/intelligence/deck-icons/brain.svg';
import cartSvg from 'bundle-text:./assets/intelligence/deck-icons/cart.svg';
import eyeSvg from 'bundle-text:./assets/intelligence/deck-icons/eye.svg';
import eyeSpeechBubbleSvg from 'bundle-text:./assets/intelligence/deck-icons/eye-speech-bubble.svg';
import flyingMoneySvg from 'bundle-text:./assets/intelligence/deck-icons/flying-money.svg';
import magnifyingGlassSvg from 'bundle-text:./assets/intelligence/deck-icons/magnifying-glass.svg';

import logoAb from 'url:./assets/logo-48-ab.png';
import logoBzr from 'url:./assets/logo-48-bzr.png';
import logoEf from 'url:./assets/logo-48-ef.png';
import logoGlx from 'url:./assets/logo-48-glx.png';
import logoKrt from 'url:./assets/logo-48-krt.png';
import logoLdl from 'url:./assets/logo-48-ldl.png';
import logoMas from 'url:./assets/logo-48-mas.png';
import logoMi from 'url:./assets/logo-48-mi.png';
import logoMm from 'url:./assets/logo-48-mm.png';
import logoPns from 'url:./assets/logo-48-pns.png';
import logoSkl from 'url:./assets/logo-48-skl.png';
import logoThn from 'url:./assets/logo-48-thn.jpg';
import logoXlk from 'url:./assets/logo-48-xlk.png';

const CONTACT_EMAIL = 'intelligence@zuper-market.gr';

const supermarketLogos = [
  { src: logoAb, alt: 'AB' },
  { src: logoSkl, alt: 'Sklavenitis' },
  { src: logoMas, alt: 'Masoutis' },
  { src: logoMi, alt: 'My Market' },
  { src: logoLdl, alt: 'Lidl' },
  { src: logoKrt, alt: 'Kritikos' },
  { src: logoMm, alt: 'Marketin' },
  { src: logoEf, alt: 'Efeon' },
  { src: logoGlx, alt: 'Galaxias' },
  { src: logoPns, alt: 'Panes' },
  { src: logoBzr, alt: 'Bazaar' },
  { src: logoXlk, alt: 'Xalkiadakis' },
  { src: logoThn, alt: 'Thanopoulos' },
];

// --- Inline icons (Heroicons outline, MIT) ---

const iconBase = 'w-6 h-6';
const iconLargeBase = 'w-7 h-7';

const Icon = {
  Storefront: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
    </svg>
  ),
  Cube: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
    </svg>
  ),
  ChartBar: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
    </svg>
  ),
  ArrowPath: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg>
  ),
  CloudDown: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z" />
    </svg>
  ),
  Sparkles: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
    </svg>
  ),
  Link: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
    </svg>
  ),
  ShieldCheck: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 5.523-4.477 10-10 10S1 17.523 1 12 5.477 2 11 2c.962 0 1.892.137 2.773.392M21 12V6a2 2 0 0 0-2-2h-3" />
    </svg>
  ),
  Signal: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
    </svg>
  ),
  Rocket: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
    </svg>
  ),
  Tag: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6Z" />
    </svg>
  ),
  Eye: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>
  ),
  Bolt: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
    </svg>
  ),
  Cpu: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z" />
    </svg>
  ),
  Puzzle: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.959.401v0a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.532.532 0 0 0-.642-.252 48.05 48.05 0 0 1-3.997.498.64.64 0 0 1-.657-.643v0Z" />
    </svg>
  ),
  ArrowRight: ({ className = 'w-4 h-4' }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  ),
  Check: ({ className = 'w-5 h-5' }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>
  ),
  Search: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>
  ),
  Calendar: ({ className = iconBase }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
    </svg>
  ),
};

// --- Deck-style large illustrations (line-art, currentColor stroke) ---

function DeckIcon({ svg, className }: { svg: string; className?: string }) {
  // the injected svg markup doesn't reliably respect the wrapper's box
  // (renders at intrinsic aspect height and overflows below it -- see the
  // hero cart bleeding into the case-study card), so pin it explicitly
  return (
    <div
      className={`${className ?? ''} [&_svg]:w-full [&_svg]:h-full`}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

const DeckArt = {
  ChartGrid: ({ className = 'w-32 h-32' }) => (
    <svg className={className} fill="none" viewBox="0 0 64 64" strokeWidth={2} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="6" width="52" height="52" rx="1" />
      <path d="M14 6v52M22 6v52M30 6v52M38 6v52M46 6v52M54 6v52" />
      <path d="M6 14h52M6 22h52M6 30h52M6 38h52M6 46h52M6 54h52" />
      <path d="M10 50l12-10 10 6 12-14 14 6" stroke="currentColor" strokeWidth={3} />
    </svg>
  ),
};

const content = {
  en: {
    meta: {
      title: 'Zuper Intelligence — Real-time supermarket prices',
      description:
        'Daily price tracking, promotions and assortment intelligence across 15+ Greek supermarket chains. For retailers and brand managers.',
    },
    nav: {
      brand: 'zuper',
      tag: 'intelligence',
      cta: 'Contact',
    },
    hero: {
      eyebrow: 'zuper intelligence',
      title: 'Real-time supermarket prices.',
      lede: 'Daily price tracking, promotions and assortment intelligence across every Greek supermarket — for retailers and brand managers.',
      cta: 'Request a demo',
      ctaSecondary: 'See how it works',
    },
    problem: {
      eyebrow: 'the problem',
      heading: 'The market moves.',
      bullets: [
        'Competitor prices change every day',
        'Promotions shift constantly',
        'Manual tracking is slow and unreliable',
        'Decisions get made on stale data',
      ],
    },
    data: {
      eyebrow: 'zuper intelligence',
      heading: 'Daily supermarket price updates.',
      stats: [
        { value: '15+', label: 'Supermarket chains, daily', icon: 'Storefront' },
        { value: '100,000+', label: 'SKUs tracked', icon: 'Cube' },
        { value: 'Aug 2024', label: 'Historical price baseline', icon: 'ChartBar' },
        { value: 'Continuous', label: 'Validation & product matching', icon: 'ArrowPath' },
      ],
      logosLabel: 'Some of the chains we monitor',
    },
    advantage: {
      eyebrow: 'our tech',
      heading: 'Continuous access to consumer-facing prices.',
      body:
        'Our tech powers Zuper Market, a leading price comparison platform in Greece.',
      bullets: [
        'Direct, continuous access to the same consumer-facing prices shoppers actually see — not retailer-reported figures.',
        'Prices reflect the real consumer experience and are captured at scale, every day, across the market.',
      ],
      linkLabel: 'Visit Zuper Market',
    },
    audiences: {
      eyebrow: 'our audience',
      heading: 'Built for two audiences.',
      retailers: {
        title: 'Retailers',
        icon: 'Storefront',
        bullets: [
          'Spot price gaps versus your competitors',
          'Tell real promotions from noise using historical baselines',
          'React quickly to competitor price moves',
          'Protect margins without losing price competitiveness',
        ],
      },
      brands: {
        title: 'Suppliers',
        icon: 'Tag',
        bullets: [
          'Share of assortment — how many of your SKUs are listed per category vs competitors, normalised across each retailer’s taxonomy',
          'Share of navigation — visibility on the digital shelf: first row, top 10, first page',
          'Availability tracking across chains and SKUs',
          'Price positioning vs competing brands and private label',
        ],
      },
    },
    tiers: {
      eyebrow: 'our tiers',
      heading: 'Flexible solutions for every need.',
      tierNames: ['Tier 1: Track', 'Tier 2: Understand', 'Tier 3: Advance'],
      featureLabel: 'Feature',
      rows: [
        { label: 'Price comparison', values: [true, true, true] },
        { label: 'Product matching', values: [true, true, true] },
        { label: 'Historical tracking', values: [true, true, true] },
        { label: 'Insights & analytics', values: [false, true, true] },
        { label: 'Price gap analysis', values: [false, true, true] },
        { label: 'Promo / price change detection', values: [false, true, true] },
        { label: 'Visual dashboards', values: [false, true, true] },
        { label: 'Update frequency', values: ['Weekly', 'Weekly', 'Daily'] },
        { label: 'Custom views', values: [false, false, true] },
        { label: 'Alerts (price / promo changes)', values: [false, false, true] },
      ],
    },
    how: {
      eyebrow: 'methodology',
      heading: 'How it works.',
      stepLabel: 'Step',
      steps: [
        { title: 'Data collection', body: 'Daily scraping across every major Greek retailer.', icon: 'CloudDown' },
        { title: 'Cleaning & normalisation', body: 'Raw data is structured into a unified product schema.', icon: 'Sparkles' },
        { title: 'Product matching', body: 'AI and rules-based logic link the same product across retailers, even when names or units differ.', icon: 'Link' },
        { title: 'Validation', body: 'Automated checks catch matching errors and outliers before data reaches clients.', icon: 'ShieldCheck' },
        { title: 'Observability', body: 'Continuous monitoring of the pipeline keeps coverage and freshness honest.', icon: 'Signal' },
        { title: 'Delivery', body: 'Dashboards, scheduled reports, or API — whichever fits your workflow.', icon: 'Rocket' },
      ],
    },
    why: {
      eyebrow: 'why choose us',
      heading: 'zuper intelligence.',
      bullets: [
        { title: 'Real consumer-facing data', body: 'From the same pipeline that powers Zuper Market.', icon: 'Eye' },
        { title: 'Daily refresh', body: 'Frequent updates keep your view of the market current.', icon: 'Bolt' },
        { title: 'Advanced product matching', body: 'AI and curated rules for the messy reality of retail data.', icon: 'Cpu' },
        { title: 'Flexible delivery', body: 'Custom solutions tailored to your team’s workflow.', icon: 'Puzzle' },
      ],
    },
    caseStudy: {
      eyebrow: 'case study',
      text: 'See what our data can do: our analysis of Greek supermarket inflation, 2024–2026.',
      linkLabel: 'Read the analysis',
      href: '/blog/plithorismos-super-market-2024-2026.html',
    },
    cta: {
      heading: 'Let’s talk.',
      body: 'Tell us what you’d like to see and we’ll come back with a walkthrough tailored to you.',
      button: 'Email our team',
    },
  },
  el: {
    meta: {
      title: 'Zuper Intelligence — Τιμές super market σε πραγματικό χρόνο',
      description:
        'Καθημερινή παρακολούθηση τιμών, προσφορών και assortment intelligence σε 15+ ελληνικά super market. Για retailers και brand managers.',
    },
    nav: {
      brand: 'zuper',
      tag: 'intelligence',
      cta: 'Επικοινωνία',
    },
    hero: {
      eyebrow: 'zuper intelligence',
      title: 'Τιμές super market σε πραγματικό χρόνο.',
      lede: 'Καθημερινή παρακολούθηση τιμών, προσφορών και assortment intelligence σε όλα τα ελληνικά super market — για retailers και brand managers.',
      cta: 'Ζητήστε demo',
      ctaSecondary: 'Δείτε πώς λειτουργεί',
    },
    problem: {
      eyebrow: 'το πρόβλημα',
      heading: 'Η αγορά κινείται.',
      bullets: [
        'Οι τιμές των ανταγωνιστών αλλάζουν καθημερινά',
        'Οι προσφορές αλλάζουν συνεχώς',
        'Η χειροκίνητη παρακολούθηση είναι αργή και αναξιόπιστη',
        'Οι αποφάσεις λαμβάνονται με ξεπερασμένα δεδομένα',
      ],
    },
    data: {
      eyebrow: 'zuper intelligence',
      heading: 'Καθημερινή ανανέωση τιμών super market.',
      stats: [
        { value: '15+', label: 'Αλυσίδες super market καθημερινά', icon: 'Storefront' },
        { value: '100.000+', label: 'SKUs υπό παρακολούθηση', icon: 'Cube' },
        { value: 'Αύγ. 2024', label: 'Ιστορική βάση τιμών', icon: 'ChartBar' },
        { value: 'Συνεχές', label: 'Validation & product matching', icon: 'ArrowPath' },
      ],
      logosLabel: 'Μερικές από τις αλυσίδες που παρακολουθούμε',
    },
    advantage: {
      eyebrow: 'η τεχνολογία μας',
      heading: 'Συνεχής πρόσβαση στις τιμές που πραγματικά βλέπει ο καταναλωτής.',
      body:
        'Η τεχνολογία μας τροφοδοτεί το Zuper Market, κορυφαία πλατφόρμα σύγκρισης τιμών στην Ελλάδα.',
      bullets: [
        'Άμεση και συνεχής πρόσβαση στις τιμές που βλέπουν οι καταναλωτές — όχι αυτές που δηλώνουν οι λιανέμποροι.',
        'Οι τιμές αντικατοπτρίζουν την εμπειρία του καταναλωτή και συλλέγονται σε κλίμακα, καθημερινά, σε όλη την αγορά.',
      ],
      linkLabel: 'Επισκεφθείτε το Zuper Market',
    },
    audiences: {
      eyebrow: 'το κοινό μας',
      heading: 'Φτιαγμένο για δύο κοινά.',
      retailers: {
        title: 'Retailers',
        icon: 'Storefront',
        bullets: [
          'Εντοπίστε διαφορές τιμών με τους ανταγωνιστές σας',
          'Ξεχωρίστε πραγματικές προσφορές με βάση ιστορικό τιμών',
          'Αντιδράστε γρήγορα σε αλλαγές τιμών των ανταγωνιστών',
          'Προστατέψτε τα περιθώρια χωρίς να χάνετε σε ανταγωνιστικότητα',
        ],
      },
      brands: {
        title: 'Προμηθευτές',
        icon: 'Tag',
        bullets: [
          'Share of assortment — πόσα δικά σας SKUs υπάρχουν ανά κατηγορία σε σχέση με τους ανταγωνιστές, κανονικοποιημένο σε όλα τα taxonomies των retailers',
          'Share of navigation — ορατότητα στο ψηφιακό ράφι: πρώτη γραμμή, top 10, πρώτη σελίδα',
          'Παρακολούθηση availability σε όλες τις αλυσίδες και τα SKUs',
          'Θέση τιμών σε σχέση με ανταγωνιστικά brands και private label',
        ],
      },
    },
    tiers: {
      eyebrow: 'τα πακέτα μας',
      heading: 'Ευέλικτες λύσεις για κάθε ανάγκη.',
      tierNames: ['Tier 1: Track', 'Tier 2: Understand', 'Tier 3: Advance'],
      featureLabel: 'Λειτουργία',
      rows: [
        { label: 'Σύγκριση τιμών', values: [true, true, true] },
        { label: 'Product matching', values: [true, true, true] },
        { label: 'Ιστορική παρακολούθηση', values: [true, true, true] },
        { label: 'Insights & analytics', values: [false, true, true] },
        { label: 'Price gap analysis', values: [false, true, true] },
        { label: 'Εντοπισμός promo / αλλαγών τιμών', values: [false, true, true] },
        { label: 'Visual dashboards', values: [false, true, true] },
        { label: 'Συχνότητα ενημέρωσης', values: ['Εβδομαδιαία', 'Εβδομαδιαία', 'Καθημερινή'] },
        { label: 'Custom προβολές', values: [false, false, true] },
        { label: 'Ειδοποιήσεις (αλλαγές τιμών / promo)', values: [false, false, true] },
      ],
    },
    how: {
      eyebrow: 'μεθοδολογία',
      heading: 'Πώς λειτουργεί.',
      stepLabel: 'Βήμα',
      steps: [
        { title: 'Συλλογή δεδομένων', body: 'Καθημερινό scraping σε όλους τους μεγάλους Έλληνες λιανέμπορους.', icon: 'CloudDown' },
        { title: 'Καθαρισμός & κανονικοποίηση', body: 'Τα δεδομένα δομούνται σε ένα ενιαίο schema προϊόντων.', icon: 'Sparkles' },
        { title: 'Product matching', body: 'AI και rules-based λογική συνδέουν το ίδιο προϊόν σε διαφορετικούς retailers, ακόμη κι όταν τα ονόματα ή οι μονάδες διαφέρουν.', icon: 'Link' },
        { title: 'Επικύρωση', body: 'Αυτοματοποιημένοι έλεγχοι εντοπίζουν λάθη matching και outliers πριν φτάσουν στους πελάτες.', icon: 'ShieldCheck' },
        { title: 'Observability', body: 'Συνεχής παρακολούθηση του pipeline εξασφαλίζει την κάλυψη και τη φρεσκάδα των δεδομένων.', icon: 'Signal' },
        { title: 'Παράδοση', body: 'Dashboards, προγραμματισμένες αναφορές, ή API — όποιο ταιριάζει στη ροή σας.', icon: 'Rocket' },
      ],
    },
    why: {
      eyebrow: 'γιατί να μας προτιμήσετε',
      heading: 'zuper intelligence.',
      bullets: [
        { title: 'Πραγματικά δεδομένα ραφιού', body: 'Από το ίδιο pipeline που τροφοδοτεί το Zuper Market.', icon: 'Eye' },
        { title: 'Καθημερινή ενημέρωση', body: 'Συχνές ενημερώσεις κρατούν την εικόνα της αγοράς πάντα τρέχουσα.', icon: 'Bolt' },
        { title: 'Προηγμένο product matching', body: 'AI και επιμελημένοι κανόνες για τη χαοτική πραγματικότητα των δεδομένων λιανικής.', icon: 'Cpu' },
        { title: 'Ευέλικτη παράδοση', body: 'Custom λύσεις προσαρμοσμένες στη ροή της ομάδας σας.', icon: 'Puzzle' },
      ],
    },
    caseStudy: {
      eyebrow: 'case study',
      text: 'Δείτε τι μπορούν να κάνουν τα δεδομένα μας: η ανάλυση του πληθωρισμού στα σούπερ μάρκετ 2024–2026.',
      linkLabel: 'Διαβάστε την ανάλυση',
      href: '/blog/plithorismos-super-market-2024-2026.html',
    },
    cta: {
      heading: 'Ας μιλήσουμε.',
      body: 'Πείτε μας τι σας ενδιαφέρει και θα σας απαντήσουμε με μια παρουσίαση φτιαγμένη στα μέτρα σας.',
      button: 'Email στην ομάδα μας',
    },
  },
};

type Lang = 'el' | 'en';
const LANG_STORAGE_KEY = 'zuper-intelligence-lang';

function getInitialLang(): Lang {
  if (typeof window === 'undefined') return 'el';
  const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
  return saved === 'en' ? 'en' : 'el';
}

function LangToggle({ lang, setLang }: { lang: Lang; setLang: (l: Lang) => void }) {
  const base = 'px-2.5 py-1 rounded-full transition-colors';
  const active = 'bg-white/15 text-white';
  const inactive = 'text-white/60 hover:text-white';
  return (
    <div className="flex items-center text-xs font-bold uppercase tracking-wider rounded-full border border-white/20 p-0.5 backdrop-blur-sm">
      <button
        onClick={() => setLang('el')}
        aria-pressed={lang === 'el'}
        className={`${base} ${lang === 'el' ? active : inactive}`}
      >EL</button>
      <button
        onClick={() => setLang('en')}
        aria-pressed={lang === 'en'}
        className={`${base} ${lang === 'en' ? active : inactive}`}
      >EN</button>
    </div>
  );
}

function TopBar({ t, lang, setLang }: { t: any; lang: Lang; setLang: (l: Lang) => void }) {
  return (
    <div className="absolute top-0 inset-x-0 z-30">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        {/* Plain <a> (full load) so leaving /intelligence re-initializes AdSense
            Auto Ads on the app pages — see the inbound link in page-landing. */}
        <a href="/" className="text-2xl font-extrabold tracking-wide text-white inline-flex items-baseline gap-1.5">
          <span>{t.nav.brand}</span>
          <span className="font-mono italic font-normal text-zuper-300">i</span>
        </a>
        <div className="flex items-center gap-3">
          <LangToggle lang={lang} setLang={setLang} />
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="hidden sm:inline-flex items-center bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-4 py-2 rounded-full border border-white/30 transition-colors"
          >
            {t.nav.cta}
          </a>
        </div>
      </div>
    </div>
  );
}

function Hero({ t, lang, setLang }: { t: any; lang: Lang; setLang: (l: Lang) => void }) {
  return (
    <section className="relative isolate overflow-hidden bg-zuper-600 text-white">
      <TopBar t={t} lang={lang} setLang={setLang} />

      <div className="relative max-w-7xl mx-auto px-6 pt-36 pb-10 md:pt-44 md:pb-12">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <SectionEyebrow>{t.hero.eyebrow}</SectionEyebrow>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight leading-[1.05] mb-6">
              {t.hero.title}
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-xl mb-10">
              {t.hero.lede}
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="inline-flex items-center gap-2 bg-white hover:bg-zuper-50 text-zuper-700 text-base font-semibold px-6 py-3 rounded-full transition-colors"
              >
                {t.hero.cta}
                <Icon.ArrowRight />
              </a>
              <a
                href="#how-it-works"
                className="inline-flex items-center gap-2 bg-transparent hover:bg-white/10 text-white text-base font-semibold px-6 py-3 rounded-full border-2 border-white/40 transition-colors"
              >
                {t.hero.ctaSecondary}
              </a>
            </div>
          </div>

          <div className="flex lg:col-span-5 justify-center items-center text-zuper-300">
            <div className="relative w-full max-w-[14rem] sm:max-w-[18rem] lg:max-w-md aspect-square">
              <DeckArt.ChartGrid className="absolute top-0 right-0 w-[40%] h-[40%]" />
              <DeckIcon svg={brainSvg} className="absolute top-[28%] left-[5%] w-[30%] h-[30%]" />
              <DeckIcon svg={cartSvg} className="absolute bottom-0 right-[3%] w-[60%] h-[40%]" />
            </div>
          </div>
        </div>

        <CaseStudyCard t={t} />
      </div>
    </section>
  );
}

function SlideDivider() {
  return (
    <div className="max-w-6xl mx-auto px-6 pt-8 md:pt-14">
      <div className="h-px bg-zuper-300" aria-hidden="true" />
    </div>
  );
}

function SectionEyebrow({ children, tone = 'light' }: { children: any; tone?: 'light' | 'dark' }) {
  const color = tone === 'light' ? 'text-zuper-300' : 'text-zuper-700';
  return (
    <p className={`text-xl md:text-2xl font-mono lowercase mb-5 ${color}`}>
      {children}
    </p>
  );
}

function Problem({ t }) {
  return (
    <section className="bg-zuper-600 text-white">
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <SectionEyebrow>{t.problem.eyebrow}</SectionEyebrow>
            <h2 className="text-3xl md:text-5xl font-extrabold mb-10">
              {t.problem.heading}
            </h2>
            <ul className="space-y-4 max-w-xl">
              {t.problem.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-lg">
                  <span className="mt-2.5 inline-block w-2 h-2 rounded-full bg-zuper-300 shrink-0" />
                  <span className="text-white/95">{b}</span>
                </li>
              ))}
            </ul>
            {t.problem.closing && (
              <p className="mt-8 text-lg text-white font-semibold">
                {t.problem.closing}
              </p>
            )}
          </div>

          <div className="flex lg:col-span-5 justify-center text-zuper-300">
            <DeckIcon svg={flyingMoneySvg} className="w-44 h-44 sm:w-56 sm:h-56 lg:w-72 lg:h-72" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Data({ t }) {
  return (
    <section className="relative bg-zuper-600 text-white overflow-hidden">
      <SlideDivider />
      <div className="relative max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="mb-12 max-w-3xl">
          <SectionEyebrow>{t.data.eyebrow}</SectionEyebrow>
          <h2 className="text-3xl md:text-5xl font-extrabold">
            {t.data.heading}
          </h2>
        </div>
        <div className="mb-14 flex justify-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-x-6 gap-y-3 px-6 py-4 rounded-2xl bg-white">
            {supermarketLogos.map((logo, i) => (
              <img
                key={i}
                src={logo.src}
                alt={logo.alt}
                className="w-12 h-12 object-contain"
              />
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {t.data.stats.map((s, i) => {
            const I = Icon[s.icon];
            return (
              <div key={i} className="flex flex-col items-start">
                <div className="text-zuper-300 mb-5">
                  <I className="w-20 h-20" />
                </div>
                <div className="text-3xl md:text-4xl font-extrabold text-white mb-2 leading-tight">
                  {s.value}
                </div>
                <div className="text-base text-white/85 leading-snug">{s.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function Advantage({ t }) {
  return (
    <section className="bg-zuper-600 text-white">
      <SlideDivider />
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-8">
            <SectionEyebrow>{t.advantage.eyebrow}</SectionEyebrow>
            <h2 className="text-3xl md:text-5xl font-extrabold mb-10">
              {t.advantage.heading}
            </h2>
            <div className="flex flex-col sm:flex-row gap-6 mb-8 text-white/95">
              <p className="flex-1 text-base leading-relaxed">{t.advantage.body}</p>
              {t.advantage.bullets.map((b, i) => (
                <p key={i} className="flex-1 text-base leading-relaxed">{b}</p>
              ))}
            </div>
            <a href="/" className="inline-flex items-center gap-2 text-zuper-300 hover:text-white font-semibold">
              {t.advantage.linkLabel}
              <Icon.ArrowRight />
            </a>
          </div>
          <div className="flex lg:col-span-4 justify-center items-center text-zuper-300 pt-4 lg:pt-10">
            <DeckIcon svg={magnifyingGlassSvg} className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Audiences({ t }) {
  const cols = [
    { title: t.audiences.retailers.title, bullets: t.audiences.retailers.bullets },
    { title: t.audiences.brands.title, bullets: t.audiences.brands.bullets },
  ];

  return (
    <section className="bg-zuper-600 text-white">
      <SlideDivider />
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <SectionEyebrow>{t.audiences.eyebrow}</SectionEyebrow>
        <div className="grid lg:grid-cols-12 gap-10 items-start mt-3">
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-10">
            {cols.map((col, i) => (
              <div key={i}>
                <h3 className="text-2xl md:text-3xl font-extrabold mb-5">{col.title}</h3>
                <ul className="space-y-3">
                  {col.bullets.map((b, j) => (
                    <li key={j} className="flex items-start gap-3">
                      <span className="mt-2.5 inline-block w-1.5 h-1.5 rounded-full bg-zuper-300 shrink-0" />
                      <span className="text-white/95 leading-relaxed">{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="flex lg:col-span-4 justify-center items-center text-zuper-300 pt-4">
            <DeckIcon svg={eyeSvg} className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Tiers({ t }) {
  const r = t.tiers;
  return (
    <section className="bg-zuper-600 text-white">
      <SlideDivider />
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="mb-10 max-w-3xl">
          <SectionEyebrow>{r.eyebrow}</SectionEyebrow>
          <h2 className="text-3xl md:text-5xl font-extrabold">
            {r.heading}
          </h2>
        </div>
        {/* Mobile: one card per tier */}
        <div className="md:hidden space-y-4">
          {r.tierNames.map((name, tierIdx) => {
            const highlight = tierIdx === 1;
            const [tier, label] = name.split(/:\s*/);
            return (
              <div
                key={tierIdx}
                className={`rounded-2xl p-6 ${highlight ? 'bg-zuper-500' : 'bg-zuper-700/30 border border-zuper-300/15'}`}
              >
                <div className="text-center mb-4 pb-4 border-b border-white/20">
                  <div className="text-xl font-extrabold text-zuper-300 leading-tight">
                    <div>{tier}</div>
                    <div>{label}</div>
                  </div>
                </div>
                <ul className="space-y-2.5 text-sm">
                  {r.rows.map((row, rowIdx) => {
                    const value = row.values[tierIdx];
                    if (value === true) {
                      return (
                        <li key={rowIdx} className="flex items-start gap-3">
                          <Icon.Check className="w-4 h-4 mt-0.5 text-white shrink-0" />
                          <span className="text-white">{row.label}</span>
                        </li>
                      );
                    }
                    if (value === false || value === null || value === undefined || value === '') {
                      return (
                        <li key={rowIdx} className="flex items-start gap-3 text-white/40">
                          <span aria-hidden="true" className="block w-4 h-4 mt-0.5 leading-none text-center shrink-0">—</span>
                          <span>{row.label}</span>
                        </li>
                      );
                    }
                    return (
                      <li key={rowIdx} className="flex items-start gap-3">
                        <Icon.Check className="w-4 h-4 mt-0.5 text-white shrink-0" />
                        <span className="text-white">
                          {row.label}: <span className="font-semibold">{value}</span>
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Desktop: comparison table */}
        <div className="hidden md:block">
          <table className="w-full min-w-[680px] text-sm" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead>
              <tr>
                <th className="text-left p-4 font-mono text-sm text-zuper-300 border-b border-white/15">
                  {r.featureLabel}
                </th>
                {r.tierNames.map((name, i) => {
                  const highlight = i === 1;
                  const [tier, label] = name.split(/:\s*/);
                  return (
                    <th
                      key={i}
                      className={`p-4 align-bottom min-w-[160px] text-center border-b border-white/15 ${highlight ? 'bg-zuper-500 rounded-t-2xl' : ''}`}
                    >
                      <div className="text-base font-extrabold text-zuper-300 leading-tight">
                        <div>{tier}</div>
                        <div>{label}</div>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {r.rows.map((row, ri) => {
                const last = ri === r.rows.length - 1;
                return (
                  <tr key={ri}>
                    <td className={`p-4 text-white font-medium ${last ? '' : 'border-b border-white/10'}`}>
                      {row.label}
                    </td>
                    {row.values.map((v, ci) => {
                      const highlight = ci === 1;
                      const cellBg = highlight ? 'bg-zuper-500' : '';
                      const borderBottom = last ? '' : (highlight ? 'border-b border-zuper-400/40' : 'border-b border-white/10');
                      const radius = highlight && last ? 'rounded-b-2xl' : '';
                      const cls = `p-4 text-center ${cellBg} ${borderBottom} ${radius}`;
                      if (v === true) {
                        return (
                          <td key={ci} className={cls}>
                            <Icon.Check className="w-5 h-5 mx-auto text-white" />
                          </td>
                        );
                      }
                      if (v === false || v === null || v === undefined || v === '') {
                        return <td key={ci} className={cls}></td>;
                      }
                      return (
                        <td key={ci} className={`${cls} text-white ${highlight ? 'font-semibold' : ''}`}>
                          {v}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function HowItWorks({ t }) {
  return (
    <section id="how-it-works" className="bg-zuper-600 text-white">
      <SlideDivider />
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="mb-10 max-w-3xl">
          <SectionEyebrow>{t.how.eyebrow}</SectionEyebrow>
          <h2 className="text-3xl md:text-5xl font-extrabold">
            {t.how.heading}
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.how.steps.map((step, i) => (
            <div key={i} className="rounded-2xl bg-white p-7">
              <span className="text-xs font-bold uppercase tracking-wider text-zuper-300 block mb-1">
                {t.how.stepLabel} {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="text-lg font-extrabold text-zuper-600 mb-2">{step.title}</h3>
              <p className="text-zuper-600 text-sm leading-relaxed">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Why({ t }) {
  return (
    <section className="bg-zuper-600 text-white">
      <SlideDivider />
      <div className="max-w-6xl mx-auto px-6 pt-6 pb-8 md:pt-14 md:pb-24">
        <div className="mb-10 max-w-3xl">
          <SectionEyebrow>{t.why.eyebrow}</SectionEyebrow>
          <h2 className="text-3xl md:text-5xl font-extrabold">
            {t.why.heading}
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {t.why.bullets.map((item, i) => {
            const I = Icon[item.icon];
            return (
              <div key={i} className="flex items-start gap-5 bg-white rounded-2xl p-7">
                <div className="flex-1">
                  <h3 className="text-lg font-extrabold text-zuper-600 mb-1.5">{item.title}</h3>
                  <p className="text-zuper-600 text-sm leading-relaxed">{item.body}</p>
                </div>
                <div className="text-zuper-300 shrink-0">
                  <I className="w-12 h-12" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function CaseStudyCard({ t }) {
  return (
    <div className="mt-16 md:mt-24">
        <a
          href={t.caseStudy.href}
          className="group flex flex-col sm:flex-row sm:items-center gap-5 bg-white/10 hover:bg-white/15 rounded-2xl p-6 sm:p-8 border border-white/15 transition-colors"
        >
          <div className="text-zuper-300 shrink-0">
            <Icon.ChartBar className="w-10 h-10" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-bold uppercase tracking-wider text-zuper-300 mb-1">
              {t.caseStudy.eyebrow}
            </p>
            <p className="text-lg font-semibold text-white">{t.caseStudy.text}</p>
          </div>
          <div className="flex items-center gap-2 text-zuper-300 font-semibold shrink-0 whitespace-nowrap group-hover:text-white transition-colors">
            {t.caseStudy.linkLabel}
            <Icon.ArrowRight className="w-4 h-4 shrink-0 group-hover:translate-x-1 transition-transform" />
          </div>
        </a>
    </div>
  );
}

function FinalCta({ t }) {
  return (
    <section className="relative bg-zuper-600 text-white overflow-hidden">
      <SlideDivider />
      <div className="relative max-w-6xl mx-auto px-6 pt-14 pb-24">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <h2 className="text-4xl md:text-6xl font-extrabold mb-5">
              {t.cta.heading}
            </h2>
            <p className="text-lg md:text-xl text-white/90 max-w-xl mb-8">
              {t.cta.body}
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="inline-flex items-center gap-2 text-zuper-300 hover:text-white text-xl md:text-2xl font-mono font-semibold transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
          </div>
          <div className="flex lg:col-span-5 justify-center items-center text-zuper-300">
            <div className="relative w-full max-w-[14rem] sm:max-w-[18rem] lg:max-w-md aspect-square">
              <DeckIcon svg={eyeSpeechBubbleSvg} className="absolute top-[8%] right-0 w-[45%] h-[45%]" />
              <DeckIcon svg={cartSvg} className="absolute bottom-0 right-[5%] w-[60%] h-[40%]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function IntelligencePage() {
  const [lang, setLang] = useState<Lang>(getInitialLang);
  const t = content[lang];

  useEffect(() => {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  }, [lang]);

  return (
    <div className="min-h-screen bg-white">
      <Helmet htmlAttributes={{ lang }}>
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
      </Helmet>

      <Hero t={t} lang={lang} setLang={setLang} />
      <Problem t={t} />
      <Data t={t} />
      <Advantage t={t} />
      <Audiences t={t} />
      <Tiers t={t} />
      <HowItWorks t={t} />
      <Why t={t} />
      <FinalCta t={t} />

      <div className="py-10 bg-white">
        <Footer />
      </div>
      <ScrollRestoration />
    </div>
  );
}
